import { createContext } from "react";
var ValidationContext = createContext({});
export { ValidationContext };